import {
  SET_CAPITALIZATION_RATE
} from "./mutations";
import {store} from "../../index";
import CapitalizationRate, {
  AfterTaxCapitalizationRate,
  PreTaxCapitalizationRate
} from "../../../models/valuation/CapitalizationRate";
import {generateForecastFreeCashFlow} from "../forecastFCF/actions";


export const generateCapitalizationRate = (options = { clearCache: false }) => (dispatch) => {
  dispatch(generateForecastFreeCashFlow())

  const { forecastFCF, capitalizationRate } = store.getState()
  if (capitalizationRate && !options.clearCache) {
    const _capitalizationRate = new CapitalizationRate({
      ...capitalizationRate.capitalizationRate,
      afterTaxCapitalizationRate: new AfterTaxCapitalizationRate({
        ...capitalizationRate?.capitalizationRate?.afterTaxCapitalizationRate
      }),
      preTaxCapitalizationRate: new PreTaxCapitalizationRate({
        ...capitalizationRate?.capitalizationRate?.preTaxCapitalizationRate,
        afterTaxFreeCashFlow: forecastFCF.forecastFreeCashFlow.forecastedFreeCashFlowAfterTax.afterTaxFreeCashFlow,
        preTaxFreeCashFlow: forecastFCF.forecastFreeCashFlow.forecastedFreeCashFlowBeforeTax.preTaxFreeCashFlow
      })
    })

    _capitalizationRate.preTaxCapitalizationRate.afterTaxNetCashFlowCapitalizationRate = _capitalizationRate.afterTaxCapitalizationRate.afterTaxNetCashFlowCapitalizationRate

    dispatch({
      type: SET_CAPITALIZATION_RATE,
      payload: _capitalizationRate
    })

    return
  }

  const _capitalizationRate =  new CapitalizationRate({
    afterTaxCapitalizationRate: new AfterTaxCapitalizationRate({

    }),
    preTaxCapitalizationRate: new PreTaxCapitalizationRate({
      afterTaxFreeCashFlow: forecastFCF.forecastFreeCashFlow.forecastedFreeCashFlowAfterTax.afterTaxFreeCashFlow
    })
  })

  dispatch({
    type: SET_CAPITALIZATION_RATE,
    payload: _capitalizationRate
  })
}

export const updateCapitalizationRate = ({
  analystNote,
  afterTaxCapitalizationRate
}) => (dispatch) => {
  const { capitalizationRate } = store.getState().capitalizationRate

  if (analystNote || analystNote === "") {
    capitalizationRate.analystNote = analystNote
  }
  if (afterTaxCapitalizationRate?.riskFreeRate != undefined) {
    capitalizationRate.afterTaxCapitalizationRate.riskFreeRate = afterTaxCapitalizationRate?.riskFreeRate
    capitalizationRate.preTaxCapitalizationRate.longTermSustainableGrowthRate = afterTaxCapitalizationRate?.riskFreeRate
  }
  if (afterTaxCapitalizationRate?.riskFreeRateNote || afterTaxCapitalizationRate?.riskFreeRateNote === "") {
    capitalizationRate.afterTaxCapitalizationRate.riskFreeRateNote = afterTaxCapitalizationRate?.riskFreeRateNote
  }
  if (afterTaxCapitalizationRate?.equityRiskPremium != undefined) {
    capitalizationRate.afterTaxCapitalizationRate.equityRiskPremium = afterTaxCapitalizationRate?.equityRiskPremium
  }
  if (afterTaxCapitalizationRate?.equityRiskPremiumNote || afterTaxCapitalizationRate?.equityRiskPremiumNote === "") {
    capitalizationRate.afterTaxCapitalizationRate.equityRiskPremiumNote = afterTaxCapitalizationRate?.equityRiskPremiumNote
  }
  if (afterTaxCapitalizationRate?.sizePremium != undefined) {
    capitalizationRate.afterTaxCapitalizationRate.sizePremium = afterTaxCapitalizationRate?.sizePremium
  }
  if (afterTaxCapitalizationRate?.sizePremiumNote || afterTaxCapitalizationRate?.sizePremiumNote === "") {
    capitalizationRate.afterTaxCapitalizationRate.sizePremiumNote = afterTaxCapitalizationRate?.sizePremiumNote
  }
  if (afterTaxCapitalizationRate?.industryRisk != undefined) {
    capitalizationRate.afterTaxCapitalizationRate.industryRisk = afterTaxCapitalizationRate?.industryRisk
  }
  if (afterTaxCapitalizationRate?.industryRiskNote || afterTaxCapitalizationRate?.industryRiskNote === "") {
    capitalizationRate.afterTaxCapitalizationRate.industryRiskNote = afterTaxCapitalizationRate?.industryRiskNote
  }
  if (afterTaxCapitalizationRate?.countryRisk != undefined) {
    capitalizationRate.afterTaxCapitalizationRate.countryRisk = afterTaxCapitalizationRate?.countryRisk
  }
  if (afterTaxCapitalizationRate?.countryRiskNote || afterTaxCapitalizationRate?.countryRiskNote === "") {
    capitalizationRate.afterTaxCapitalizationRate.countryRiskNote = afterTaxCapitalizationRate?.countryRiskNote
  }
  if (afterTaxCapitalizationRate?.riskPremiumCompanySpecificRisks != undefined) {
    capitalizationRate.afterTaxCapitalizationRate.riskPremiumCompanySpecificRisks = afterTaxCapitalizationRate?.riskPremiumCompanySpecificRisks
  }
  if (afterTaxCapitalizationRate?.riskPremiumCompanySpecificRisksNote || afterTaxCapitalizationRate?.riskPremiumCompanySpecificRisksNote === "") {
    capitalizationRate.afterTaxCapitalizationRate.riskPremiumCompanySpecificRisksNote = afterTaxCapitalizationRate?.riskPremiumCompanySpecificRisksNote
  }

  capitalizationRate.preTaxCapitalizationRate.afterTaxNetCashFlowCapitalizationRate = capitalizationRate.afterTaxCapitalizationRate.afterTaxNetCashFlowCapitalizationRate

  dispatch({
    type: SET_CAPITALIZATION_RATE,
    payload: new CapitalizationRate({
      ...capitalizationRate,
      afterTaxCapitalizationRate: new AfterTaxCapitalizationRate({
        ...capitalizationRate.afterTaxCapitalizationRate
      }),
      preTaxCapitalizationRate: new PreTaxCapitalizationRate({
        ...capitalizationRate.preTaxCapitalizationRate
      })
    })
  })
}

